import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import { usePageMeta } from "@/hooks/usePageMeta";
import { contactChannels, positionPillars, principles, testimonials } from "@/mocks/about";
import ContactForm from "./components/ContactForm";

export default function About() {
  usePageMeta({
    title: "关于我们 - 17吃瓜社区 | 一个好好聊娱乐话题的地方",
    description:
      "17吃瓜社区是一个中文娱乐话题讨论社区。了解我们的品牌定位、发展理念、内容原则与用户口碑,欢迎通过联系表单和我们交流。",
    keywords: "17.cn,17.cn吃瓜社区,吃瓜社区介绍,娱乐话题社区,网友讨论社区",
    path: "/about",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        name: "关于我们 - 17吃瓜社区",
        description: "17吃瓜社区的定位、理念与内容原则。",
        url: "https://17.cn/about",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "17吃瓜社区",
        url: "https://17.cn/",
        email: "hello@17.cn",
        description: "中文娱乐话题讨论社区,涵盖影视、综艺、舞台演出与网络热点。",
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://17.cn/" },
          { "@type": "ListItem", position: 2, name: "关于我们", item: "https://17.cn/about" },
        ],
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16 md:pt-20">
        <section className="px-4 md:px-10 pt-10 md:pt-14">
          <nav aria-label="面包屑" className="text-xs md:text-sm text-foreground-500 mb-4">
            <ol className="flex items-center gap-2 flex-wrap">
              <li><Link to="/" className="hover:text-primary-700 transition-colors cursor-pointer">首页</Link></li>
              <li aria-hidden="true" className="text-foreground-300">/</li>
              <li className="text-foreground-800">关于我们</li>
            </ol>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center py-6 md:py-10">
            <div>
              <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 mb-4">
                <i className="ri-heart-3-line"></i>
                品牌介绍
              </span>
              <h1 className="font-heading font-black text-3xl md:text-5xl text-foreground-950 leading-tight">
                让每一个观点,
                <br className="hidden sm:block" />
                都能被认真读到
              </h1>
              <p className="text-base text-foreground-600 mt-5 leading-relaxed">
                17吃瓜社区创立于一群爱聊娱乐话题的网友之间。我们不想做又一个比谁声音大的地方,而是想做一个能安静下来、把一件事聊清楚的地方。影视、综艺、舞台演出、网络热点,只要有讨论价值,这里就有它的位置。
              </p>
              <div className="mt-7 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/topics"
                  className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-compass-3-line"></i>
                  逛逛话题广场
                </Link>
                <a
                  href="#contact"
                  className="px-6 py-3 rounded-md bg-background-100 border border-background-300 text-foreground-800 text-sm font-medium whitespace-nowrap hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-mail-send-line"></i>
                  联系社区团队
                </a>
              </div>
            </div>

            <div className="w-full h-72 md:h-96 rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20a%20cozy%20round%20table%20surrounded%20by%20warm%20speech%20bubbles%20and%20cups%20of%20tea%2C%20cream%20background%20with%20terracotta%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20minimalist%20magazine%20art%20style&width=1000&height=800&seq=gossip-about-main&orientation=landscape"
                alt="17吃瓜社区品牌插画 - 网友围坐讨论的场景"
                title="17吃瓜社区 品牌介绍"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </section>

        <section className="px-4 md:px-10 py-14 md:py-20 bg-background-100">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">网站定位</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mb-8 leading-relaxed">
            我们不生产话题,我们只是给话题找一个合适的桌子。这三件事,是17吃瓜社区一直想做好也一直在做的。
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {positionPillars.map((p) => (
              <div key={p.title} className="p-6 rounded-lg bg-background-50 border border-background-200/80">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 mb-4">
                  <i className={`${p.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading font-semibold text-lg text-foreground-950">{p.title}</h3>
                <p className="text-sm text-foreground-600 mt-2.5 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section id="principles" className="px-4 md:px-10 py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div>
              <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full bg-accent-100 text-accent-900 mb-4">
                <i className="ri-scales-3-line"></i>
                发展理念与内容原则
              </span>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">我们把讨论的边界,写在这里</h2>
              <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
                一个社区的氛围,是靠一条条具体的规则慢慢养出来的。下面这几条,是我们对每一位来到这里的网友的期待,也是我们自己一直在守着的。
              </p>
            </div>
            <div className="lg:col-span-2 flex flex-col gap-4">
              {principles.map((p, i) => (
                <div key={p.title} className="flex gap-4 p-5 rounded-lg bg-background-100 border border-background-200/80">
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 font-heading font-bold text-sm">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-base text-foreground-950">{p.title}</h3>
                    <p className="text-sm text-foreground-600 mt-1.5 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-10 py-14 md:py-20 bg-background-100">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">网友怎么说</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mb-8">来自社区里几位常驻网友的真实反馈。</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {testimonials.map((t) => (
              <blockquote key={t.name} className="p-6 rounded-lg bg-background-50 border border-background-200/80">
                <div className="flex items-center gap-1 mb-3 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className={i < t.stars ? "ri-star-fill" : "ri-star-line text-background-300"}></i>
                  ))}
                </div>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">“{t.text}”</p>
                <footer className="mt-4 flex items-center gap-3">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-900 text-sm font-medium">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </footer>
              </blockquote>
            ))}
          </div>
        </section>

        <section id="contact" className="px-4 md:px-10 py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-7">
                不管是内容反馈、合作洽谈,还是想加入创作者一起聊,都欢迎联系。我们会认真读每一条留言。
              </p>
              <ul className="flex flex-col gap-4">
                {contactChannels.map((c) => (
                  <li key={c.label} className="flex items-center gap-4 p-4 rounded-lg bg-background-100 border border-background-200/80">
                    <span className="w-11 h-11 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                      <i className={`${c.icon} text-xl`}></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">{c.label}</p>
                      <a href={`mailto:${c.value}`} className="text-sm font-medium text-foreground-900 hover:text-primary-700 transition-colors cursor-pointer">{c.value}</a>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <ContactForm />
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}